import { render } from "./ScanDocumentsView.vue?vue&type=template&id=d361ead8&scoped=true"
import script from "./ScanDocumentsView.vue?vue&type=script&lang=js"
export * from "./ScanDocumentsView.vue?vue&type=script&lang=js"

import "./ScanDocumentsView.vue?vue&type=style&index=0&id=d361ead8&lang=scss&scoped=true"
import "./ScanDocumentsView.vue?vue&type=style&index=1&id=d361ead8&lang=css"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d361ead8"]])

export default __exports__